import React, { useEffect, useState } from 'react';
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { managerApi } from 'apis/manager/managerApis';
import useAuthDropListQuery from 'hooks/queries/common/useAuthDropListQuery';
import { useProjectDropList } from 'hooks/queries/common/commonDropListQuery';
import DefaultLayout from 'components/layout/DefaultLayout';
import MainTable from 'components/table/MainTable';
import DefaultSelect from 'components/select/DefaultSelect';
import DeletePopConfirm from 'components/button/DeletePopConfirm';
import CircleButton from 'components/button/CircleButton';
import ManagerDetailInfoCard from './ManagerDetailInfoCard';
import TableToolbar from 'components/table/TableToolbar';
import ManagerUpdateModal from './ManagerUpdateModal';
import DefaultButton from 'components/button/DefaultButton';
import { useTranslation } from 'react-i18next';
/**
 * * 관리자 관리 - 관리자 상세 페이지
 */

const ManagerDetailPage = () => {
  const { t } = useTranslation();
  const { userId } = useParams();

  const [visible, setVisible] = useState(false);
  const [managerProjectAuthList, setManagerProjectAuthList] = useState(); // 관리자가 관리하는 프로젝트 리스트
  const [managerData, setManagerData] = useState();

  const { data: authDropData } = useAuthDropListQuery(); // 권한 드롭다운 데이터 리스트
  const { data: projectDropList } = useProjectDropList(); // 작품 드롭다운 리스트

  /// 수정 클릭 => 모달 열기
  const handleOpen = () => {
    setVisible(true);
  };

  /// 작품 추가
  const handleAddProject = () => {
    setManagerProjectAuthList([
      ...managerProjectAuthList,
      {
        key: managerProjectAuthList.length,
        project_id: '',
        project_name: '',
        auth_kind_name: '조회 권한',
        auth_kind: 'select',
      },
    ]);
  };

  /// 작품 셀렉트
  const handleProjectSelect = (value, option) => {
    setManagerProjectAuthList(
      managerProjectAuthList?.map((v) =>
        v.key === option.id
          ? { ...v, project_id: value, project_name: option.children }
          : v,
      ),
    );
  };

  /// 권한 셀렉트
  const handleAuthSelect = (value, option) => {
    setManagerProjectAuthList(
      managerProjectAuthList?.map((v) =>
        v.key === option.id
          ? { ...v, auth_kind: value, auth_kind_name: option.children }
          : v,
      ),
    );
  };

  /// 데이터 저장
  const handleSubmit = async () => {
    const vaildTest = managerProjectAuthList.filter(
      (data) => data.project_id === '',
    );

    if (vaildTest.length >= 1) {
      if (window.confirm(t('managerID.confirmSubmitMessage')) === true) {
        let filterArr = [];
        managerProjectAuthList.map((v) => {
          if (v.project_id !== '' || v.auth_kind !== undefined) {
            filterArr.push(v);
          }
        });
        let deleteFilter = [];
        managerProjectAuthList.map((v) => {
          if (v.project_id !== '') {
            deleteFilter.push(v);
          }
        });

        let finalData = [];
        filterArr.map((v) => {
          finalData.push({ project_id: v.project_id, auth_kind: v.auth_kind });
        });
      } else {
        return false;
      }
    }

    let filterArr = [];
    managerProjectAuthList.map((v) => {
      if (v.project_id !== '' || v.auth_kind !== undefined) {
        filterArr.push(v);
      }
    });
    let deleteFilter = [];
    managerProjectAuthList.map((v) => {
      if (v.project_id !== '') {
        deleteFilter.push(v);
      }
    });

    let finalData = [];
    filterArr.map((v) => {
      finalData.push({ project_id: v.project_id, auth_kind: v.auth_kind });
    });

    setManagerProjectAuthList(deleteFilter);

    const response = await managerApi.projectAuthUpdate(userId, deleteFilter);
    if (response !== false) {
      fetchData();
      message.success(t('managerID.successSubmitMessage'), 1);
    }
  };

  /// 작품 행 삭제
  const handleDelete = (record) => async () => {
    const res = await managerApi.projectAuthDelete(
      userId,
      String(record.project_id),
    );
    if (!res) {
      return false;
    }
    message.success(t('managerID.successDeleteMessage'), 1);
    fetchData();
  };

  /// 관리자 상세 정보 불러오기
  const fetchData = async () => {
    const res = await managerApi.detail(userId); // 상세 정보
    const resProjectAuthList = await managerApi.getProjectAuthList(userId); // 관리 프로젝트 리스트
    setManagerData(res);
    setManagerProjectAuthList(resProjectAuthList);
  };

  const columnsOrigin = [
    {
      title: t('managerID.table.projectID'),
      dataIndex: 'project_id',
      width: '8rem',
    },
    {
      title: t('managerID.table.projectName'),
      width: '15rem',
      dataIndex: 'project_name',
      render: (text, record) =>
        record.project_name ? (
          <span>{record.project_name}</span>
        ) : (
          <DefaultSelect
            name='project_id'
            id={record.key}
            value={record.project_id}
            optionList={projectDropList}
            onChange={handleProjectSelect}
            style={{ width: '100%' }}
          />
        ),
    },
    {
      title: t('managerID.table.authKindName'),
      dataIndex: 'auth_kind_name',
      width: '15rem',
      render: (text, record) => (
        <DefaultSelect
          name='auth_kind'
          id={record.key}
          value={record.auth_kind}
          optionList={authDropData}
          onChange={handleAuthSelect}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: t('managerID.table.motion'),
      dataIndex: 'motion',
      width: '10rem',
      render: (text, record) => (
        <DeletePopConfirm
          title={t('managerID.table.deleteConfirm')}
          onConfirm={handleDelete(record)}
        />
      ),
    },
  ];
  useEffect(() => {
    fetchData().catch(console.log);
  }, []);
  return (
    <>
      <DefaultLayout>
        <ManagerDetailInfoCard record={managerData} onClick={handleOpen} />
        <TableToolbar>
          <div></div>
          <DefaultButton onClick={handleSubmit}>
            {t('managerID.header.addButton')}
          </DefaultButton>
        </TableToolbar>
        <MainTable
          columns={columnsOrigin}
          dataSource={managerProjectAuthList}
          pagination={false}
        />
        <div style={{ textAlign: 'right', margin: '1rem 0' }}>
          <CircleButton onClick={handleAddProject}>+</CircleButton>
        </div>
      </DefaultLayout>

      {/* 수정 모달 */}
      <ManagerUpdateModal
        visible={visible}
        setVisible={setVisible}
        managerData={managerData}
        setManagerData={setManagerData}
        fetchData={fetchData}
        authDropData={authDropData}
      />
    </>
  );
};

export default ManagerDetailPage;
